import { ModuleWithProviders, NgModule } from '@angular/core';
import { APP_BASE_HREF, CommonModule, DatePipe } from '@angular/common';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { HttpEndpointsModule, ServiceHttpModule } from '@gp-angular/service/http';
import { SharedDirectiveModule } from '@gp-angular/shared/directive';
import { PermissionGuard } from '@gp-angular/shared/guard';

@NgModule({
	imports: [
		CommonModule,

		SharedDirectiveModule,

		MatAutocompleteModule
	],
	exports: [
		ServiceHttpModule
	],
	providers: [
		{provide: APP_BASE_HREF, useValue: '/'},
		{provide: MAT_DATE_LOCALE, useValue: 'de-DE'},

		ServiceHttpModule,

		DatePipe,
		PermissionGuard,

		{
			provide: 'externalSafeUrl',
			useValue: (route: ActivatedRouteSnapshot) => {
				window.location.href = route.data.externalUrl;
			}
		}
	]
})
export class SharedModule {
	static forRoot(): ModuleWithProviders<SharedModule> {
		return {
			ngModule: SharedModule,
			providers: [ServiceHttpModule, HttpEndpointsModule]
		};
	}
}
